import React, { Fragment } from 'react';
import { useStyles } from './categories.style';
import category from 'Assets/img/svg/categories/categoriesImage.svg';
import categoryMobile from 'Assets/img/svg/categories/categoriesMobile.svg';
import Header from 'Components/Header/Header';
import { categories } from 'Utils/options';
import MenuCard from 'Components/Reusable/Menu/MenuCard';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import fineMotorMobileBg from 'Assets/img/svg/Backgrounds/fineMotor/bgMobile.svg';
import grossMotorMobileBg from 'Assets/img/svg/Backgrounds/grossMotor/bgMobile.svg';
import sensoryMobileBg from 'Assets/img/svg/Backgrounds/sensory/bgMobile.svg';
import socialEmotionalMobileBg from 'Assets/img/svg/Backgrounds/socialEmotional/bgMobile.svg';
import communicationMobileBg from 'Assets/img/svg/Backgrounds/communication/bgMobile.svg';
import congnitiveMobileBg from 'Assets/img/svg/Backgrounds/cognitive/bgMobile.svg';

const Categories = () => {
	const classes = useStyles();
	const matches = useMediaQuery('(max-width:440px)');
	const newCategories = categories.map(category => {
		const then =
			category.type === 'Fine Motor'
				? fineMotorMobileBg
				: category.type === 'Gross Motor'
				? grossMotorMobileBg
				: category.type === 'Cognitive'
				? congnitiveMobileBg
				: category.type === 'Social Emotional'
				? socialEmotionalMobileBg
				: category.type === 'Sensory'
				? sensoryMobileBg
				: category.type === 'Communication'
				? communicationMobileBg
				: ' ';
		return {
			...category,
			backgroundImage: matches ? then : category.backgroundImage,
		};
	});
	return (
		<Fragment>
			<div className="">
				<Header />
				<div className={`${classes.menuHeaderBackground} d-flex flex-row justify-content-center`} />
				<div className={classes.textOverlay}>
					<h3 className="text-center">James </h3>
					<h6 className="text-center">11 Months </h6>
					<h5 className={classes.fontSize}>
						[child&apos;s name], look how you have grown in the last 4 years! You figured out how to operate
						an unfamiliar body, learned at least one language, explored and regulated your emotions, figured
						out how to get along with others, as well as learned to feed & dress yourself. Impressive. Our
						time together is over. We are so proud of all of your achievements. We will miss you.
					</h5>
				</div>
			</div>
			<ul className={classes.listItems}>
				{newCategories.map(content => (
					<li key={content.id} className="my-4">
						{
							<MenuCard
								url={content.url}
								image={content.backgroundImage}
								type={content.type}
								common={{ width: '100%', height: '80.74px' }}
								description={content.description}
								icon={content.icon}
								isCategory
							/>
						}
					</li>
				))}
			</ul>
		</Fragment>
	);
};

export default Categories;
